import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {DynamicListComponent} from "../../../app/shared/dynamic-list/dynamic-list.component";
import {GetMyPrice, productCrudUtility} from "./ProductUtility";
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {GetFromLocalStorage, SaveToLocalStorage} from "../../Utility/Utility";
import {DynamicEditComponent} from "../../../app/shared/dynamic-edit/dynamic-edit.component";
import {FieldViewerComponent} from "../../../app/shared/field-viewer/field-viewer.component";
export function getInitials(phrase: string): string {
  if (!phrase) return "";

  const words = phrase.trim().split(/\s+/);

  if (words.length === 1) {
    return words[0][0]?.toUpperCase() ?? "";
  }

  const first = words[0][0];
  const last = words[words.length - 1][0];

  return `${first}${last}`.toUpperCase();
}
export const bgColorClasses = [
  "neg-bg-color-red",
  "neg-bg-color-orange",
  "neg-bg-color-amber",
  "neg-bg-color-yellow",
  "neg-bg-color-lime",
  "neg-bg-color-green",
  "neg-bg-color-emerald",
  "neg-bg-color-teal",
  "neg-bg-color-sky",
  "neg-bg-color-blue",
  "neg-bg-color-indigo",
  "neg-bg-color-violet",
  "neg-bg-color-purple",
  "neg-bg-color-fuchsia",
  "neg-bg-color-pink",
  "neg-bg-color-rose",
  "neg-bg-color-gray",
  "neg-bg-color-slate",
  "neg-bg-color-zinc",
  "neg-bg-color-stone"
];

export const segBgColorClasses = [
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "emerald",
  "teal",
  "sky",
  "blue",
  "indigo",
  "violet",
  "purple",
  "fuchsia",
  "pink",
  "rose",
  "gray",
  "slate",
  "zinc",
  "stone"
];

function Segui(){
  var OBJ: OggettoConfig = {
    Id: "segui",
    RestRoute: '/anagrafica/clienti',
    listView: 'card-list',
    ListResponseHasData:true,
    ListDefaultFilter: {preferiti:false,},
    PrintHeaders:[],
    cardPerRow:1,
    listClass: 'list-preferiti',
    listTitle: 'Segui',
    hasHeader: true,
    hasViewSwitch: false,
    DisableEdit:true,
    Filters:[
    ],
    campi:[
      CampoAggiuntivo.Html("", ()=>`
      <div class="atb"><div class="ptitle">Segui</div></div>
`),
      {
        class:'col-12',
        nome: "Negozio",
        type:'Tabs',
        DisableEdit:true,

        TabSettings: {
          CrudSettings: (x)=>{
            return {ConcatParams: {}, filtro: {}}
          },
          defaultTab: (x)=>'Negozi'
        },
        tabs:[
          {
            id: 'Negozi',
            titolo: 'Negozio',
            tipo: 'crud',
            crud: 'negozi',
          },
          {
            id: 'Marca',
            titolo: 'Marca',
            tipo: 'campi',
            campi: [
              CampoAggiuntivo.Crud("", MarcaSeguita(), {prevDivClass: 'col-lg-12', class: 'col-12 list-marca'}),
              CampoAggiuntivo.Crud("", MarcaNonSeguita(), {prevDivClass: 'col-lg-12', class: 'col-12 list-marca'})
            ]
          }
          ]
      }
    ],



    MenuItems:[
      {
        path: 'shared/dynamicedit/segui',
        title: "Segui",
        icon: "fas fa-cart",
        class: "",
        capacita: [],
      }
    ]
  }
  return OBJ;
}


function MarcaSeguita(){
  return {
    ...Marca(),
    Id: 'marcafollowed',
    asyncFullResponseMap: (response: any | any[], component: DynamicListComponent, callBack: (response)=>any)=>{
      response=  response.map(x=>{return {...x, iconColorClass :segBgColorClasses[Math.floor(Math.random() * segBgColorClasses.length)]}}).filter(IsMarcaPref);
      callBack(response);
    },
    listTitle: 'Brand che segui',
  }
}
function MarcaNonSeguita(){
  return {
    ...Marca(),
    Id: 'marcaunfollowed',
    RestRoute: '/settings/get',
    fullListRoute: '/prodotti/marca/top',
    listIsGet:true,
    ListResponseHasData:false,
    asyncFullResponseMap: (response: any | any[], component: DynamicListComponent, callBack: (response)=>any)=>{
      component.authSvc.getProfile();
      response=  response.map(x=>{return {...x, iconColorClass :segBgColorClasses[Math.floor(Math.random() * segBgColorClasses.length)]}}).filter(IsntMarcaPref);
      callBack(response);
    },
    listTitle: 'Brand che potrebbero interessarti',
  }
}

export function IsMarcaPref(x){
  var marche = GetFromLocalStorage('currentUser').marche
  if(Array.isArray(marche))
  return GetFromLocalStorage('currentUser').marche?.includes(x.id);
  if(!marche)
    return false;
  if(typeof marche == 'object')
    Object.getOwnPropertyNames(marche).forEach(key => {
      if(marche[key] == x.id)
        return true;
    })
}
export function IsntMarcaPref(x){
  return !IsMarcaPref(x);
}

function Marca(){
  var Obj: OggettoConfig = {
    Id: 'marca-seguiti',
    RestRoute: '/settings/get',
    fullListRoute: '/settings/get',
    listView: 'card',
    ListResponseHasData:false,
    ListDefaultFilter: {id:'marca_prodotto', type: 'marca_prodotto'},
    PrintHeaders:[],
    cardPerRow:5,
    cardClass:'seg-brand-item',
    listTitle: 'Brand che segui',
    hasHeader: true,

    hasViewSwitch: false,
    Filters:[

    ],
    Headers: [
      CampoAggiuntivo.Html("", (marca)=>{
        return `
        <div class="seg-brand-box seg-brand-bg-${marca.iconColorClass}" >
          <span class="seg-brand-color-${marca.iconColorClass} seg-brand-nome" >
            ${marca.label}
          </span>
        </div>
        `;
      }, ()=>true, {
        onClick:(x,component)=>{
          var filters = {marche: [x.id, null]}
          component.router.navigate(['marketplace/shared/dynamiclist', 'catalogo'], {queryParams: filters})
      }
      }),
      CampoAggiuntivo.TextField("Marca", 'label', "seg-brand-item-name",{
        modificabile:false,
        style:{
          'color': '#0F172A',
          'white-space': 'nowrap',
          'overflow': 'hidden',
          'text-overflow': 'ellipsis',
          'margin-bottom': '20px',
          'text-align': 'center'
        }
      })
    ],
    AzioniLista:[
      {
        nome: 'Non seguire più',
        close: false,
        icon: 'fas fa-check',
        class: '  seg-brand-btn followed',
        single:true,
        labelClass: 'text-white ',
        noGet:true,
        type: 'func',
        tooltip: "Non seguire più",
        hideif:{func: IsMarcaPref},
        func:(field:any, api:ApiPathsService, onEnd: ()=>void, Toastr:ToastrService)=>{

          api.ClassicPost('/anagrafica/clienti/marca/delete', {id: field.id}).subscribe(
            (res)=>{
              var User = GetFromLocalStorage('currentUser');
              User.marche = User.marche?.filter(x=>x!=field.id) ?? [];
              SaveToLocalStorage('currentUser', User);
              Toastr.success("Marca rimossa dai seguiti");
              onEnd()
            }
          )
        },
      },
      {
        nome: 'Segui',
        close: false,
        icon: 'fas fa-plus',
        class: '   seg-brand-btn',
        noGet:true,
        single:true,
        labelClass: ' ',
        type: 'func',
        //tooltip: "Segui il negozio",
        hideif:{func: IsntMarcaPref},
        func:(field:any, api:ApiPathsService, onEnd: ()=>void, Toastr:ToastrService)=>{
          api.ClassicPost('/anagrafica/clienti/marca/add', {id: field.id}).subscribe(
            (res)=>{
              var User = GetFromLocalStorage('currentUser');
              User.marche = [...(User.marche ?? []), field.id];
              SaveToLocalStorage('currentUser', User);
              Toastr.success("Marca seguita");
              onEnd()
            }
          )
        },
      },


    ],
  }
  return Obj;
}

export function IsNegozioPref(x){
  return GetFromLocalStorage('currentUser').negozi?.includes(x.id);
}
export function  IsntNegozioPref(x){
  return !GetFromLocalStorage('currentUser').negozi?.includes(x.id);
}
export function FollowNegozio(field, api: ApiPathsService, Toastr:ToastrService ){
  api.ClassicPost('/anagrafica/clienti/negozio/add', {id: field.id}).subscribe(
    (res)=>{
      var User = GetFromLocalStorage('currentUser');
      User.negozi = [...(User.negozi ?? []), field.id];
      SaveToLocalStorage('currentUser', User);
      Toastr.success("Negozio seguito");
    }
  )
}
export function UnfollowNegozio (field,api: ApiPathsService, Toastr:ToastrService){
  api.ClassicPost('/anagrafica/clienti/negozio/delete', {id: field.id}).subscribe(
    (res)=>{
      var User = GetFromLocalStorage('currentUser');
      User.negozi = User.negozi?.filter(x=>x!=field.id) ?? [];
      SaveToLocalStorage('currentUser', User);
      Toastr.success("Negozio rimosso dai seguiti");
    }
  )
}

function Negozi() {



  var OBJ: OggettoConfig = {
    Id: "negozi",
    RestRoute: '/anagrafica/clienti',
    listView: 'card-list',
    ListResponseHasData:true,
    ListDefaultFilter: {size:1,},
    PrintHeaders:[],
    cardPerRow:1,
    //listClass: 'list-preferiti',
    listTitle: 'Segui',
    hasHeader: false,
    hasViewSwitch: false,
    asyncFullResponseMap: (response: any | any[], component: DynamicListComponent, callBack: (response)=>any)=>{
      component.authSvc.getProfile();
      component.authSvc.currentUser.subscribe(current => {
        response.data = current['negoziObject']?.map(x=>{return {...x, iconColorClass :bgColorClasses[Math.floor(Math.random() * bgColorClasses.length)]}})
        callBack(response);
      })
    },
    Filters:[
    ],
    cardClass:'card-segui',

    Headers: [

      CampoAggiuntivo.Html("Negozio", (item, parent)=>{

       return `<div class="seg-neg-header">
        <div class="seg-neg-logo ${item.iconColorClass}" >${getInitials(item.label)}</div>
          <div class="seg-neg-hinfo">
        <div class="seg-neg-name" >${item.label}</div>
        <div class="seg-neg-sub">
            <span class="seg-neg-arrivals">${item.numProdotti} prodotti disponibili</span>
        </div>
        </div>
          </div>`

      }),
      CampoAggiuntivo.CardList({
        url: '/prodotti/list',
        class: 'col-lg-12',
        parameter: [{nome:'page', value: 1}, {nome:'size', value: 6}, {nome:'negozio', parameter: 'id'}],
        responseHasData: true,
        responseMap:(data, permission, Oggetto)=>{
          return data.map(x=>{return{ imageUrl: `/file/image/${x.id_immagine}`, badgebl: `€${GetMyPrice(x, GetFromLocalStorage('currentUser')).prezzoIvato?.toFixed(2)}`}})
        }

      })
    ],



    AzioniLista:[
      {
        nome: 'Non seguire più',
        close: false,
        icon: 'fas fa-check',
        class: ' btn rounded seg-follow-toggle followed',
        single:true,
        labelClass: 'text-white ',
        type: 'func',
        tooltip: "Non seguire più",
        hideif:{func: IsNegozioPref},
        func:(field:any, api:ApiPathsService, onEnd: ()=>void, Toastr:ToastrService)=>{
          UnfollowNegozio(field, api, Toastr);
        },
      },
      {
        nome: 'Segui',
        close: false,
        icon: 'fas fa-plus',
        class: ' btn  seg-follow-toggle',
        single:true,
        labelClass: ' ',
        type: 'func',
        //tooltip: "Segui il negozio",
        hideif:{func: IsntNegozioPref},
        func:(field:any, api:ApiPathsService, onEnd: ()=>void, Toastr:ToastrService)=>{
          FollowNegozio(field, api, Toastr);

        },
      },
      {
        nome: 'Visualizza',
        close: false,
        icon: '',
        class: ' btn bg-black',
        single:true,
        labelClass: 'text-white ',
        type: 'func',
        //tooltip: "visualizza",
        func:(field:any, api:ApiPathsService, onEnd: ()=>void, Toastr:ToastrService, component: FieldViewerComponent)=>{
          component.router.navigate(['marketplace/shared/dynamicedit/dettaglio_negozio', field?.id])
        },
      },

    ],

  }
  return OBJ;
}


export var SeguiEnv = () => {
  var env: any = {
    Modules: {
      "segui": true
    },
    Cruds: [Segui(), Negozi(), MarcaSeguita(), MarcaNonSeguita()],
    Menu: [...Segui().MenuItems]
  }
  return env;

}
